import { encrypt } from '@/common/securityUtils';
import { Form, useForm } from '@/components/forms';
import Input from '@/components/forms/Input';
import Select from '@/components/forms/Select';
import { useDynamicLocale } from '@/hoslog-intl';
import { z } from 'zod';
import { useUpdateCustomerWithdrawal } from './hooks/useUpdateCustomerWithdrawal';

const schema = z.object({
  userType: z.string().min(1, { message: 'common.form.validation.required' }),
  minAmount: z.string().refine((value) => value !== '0' && Number(value) >= 1, {
    message: 'common.form.validation.required',
  }),
  maxAmount: z.string().refine((value) => value !== '0' && Number(value) >= 1, {
    message: 'common.form.validation.required',
  }),
});

const minAmountOptions = [{ label: '5,000', value: '5000.00' }];
const maxAmountOptions = [{ label: '20,000', value: '20000.00' }];

export const ManageCustomerWithdrawal = ({
  defaultValues,
  withdrawalId,
}: {
  defaultValues: {
    userType: string;
    minAmount: string;
    maxAmount: string;
  };
  withdrawalId?: string;
}) => {
  const { t } = useDynamicLocale();
  const { mutateAsync } = useUpdateCustomerWithdrawal();

  const form = useForm({ schema, mode: 'onBlur', defaultValues });

  return (
    <Form
      form={form}
      onSubmit={async (data) => {
        await mutateAsync({
          userType: encrypt('3'),
          maxAmount: Number(data.maxAmount),
          minAmount: Number(data.minAmount),
          withdrawalId: withdrawalId || '',
        });
      }}
    >
      <div className="w-full flex flex-col gap-[18px]">
        <Input
          label="configurationManagement.withdrawalSetup.customer.manageCustomerWithdrawal.userType"
          {...form.register('userType')}
          forceRequired
          disabled
        />
        <div className="grid grid-cols-2 gap-4">
          <Select
            options={minAmountOptions}
            label="configurationManagement.withdrawalSetup.customer.manageCustomerWithdrawal.minAmount"
            placeholder={t('common.form.placeholder.select')}
            {...form.register('minAmount')}
            forceRequired
            disabled
          />
          <Select
            options={maxAmountOptions}
            label="configurationManagement.withdrawalSetup.customer.manageCustomerWithdrawal.maxAmount"
            placeholder={t('common.form.placeholder.select')}
            {...form.register('maxAmount')}
            forceRequired
            disabled
          />
        </div>
      </div>
    </Form>
  );
};
